import {
	FETCH_SPECIAL_CODE_BEGIN,
	FETCH_SPECIAL_CODE_SUCCESS,
	FETCH_SPECIAL_CODE_FAILURE
} from '../actions/validateSpecialCode'

const initialState = {
	availability: {},
	loading: false,
	error: null
}

export default function validateSpecialCodeReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_SPECIAL_CODE_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_SPECIAL_CODE_SUCCESS:
			return {
				...state,
				loading: false,
				availability: action.payload,
				error: null,
			}

		case FETCH_SPECIAL_CODE_FAILURE:
			return {
				...state,
				loading: false,
				availability: {},
				error: action.payload.error,
			}

		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/reducers/validateSpecialCodeReducers.js